import { Shield, MapPin, Award, Eye } from 'lucide-react';

const trustItems = [
  { icon: Shield, label: 'Licensed & Insured' },
  { icon: MapPin, label: 'Southern Utah' },
  { icon: Award, label: 'Quality Craftsmanship' },
  { icon: Eye, label: 'Full Project Transparency' },
];

export const TrustStrip = () => {
  return (
    <section data-testid="trust-strip" className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {trustItems.map((item, index) => (
            <div key={item.label} className={`text-center animate-fade-in-up animate-delay-${(index + 1) * 100}`}>
              <div className="w-14 h-14 rounded-full bg-sky-50 flex items-center justify-center mx-auto mb-4">
                <item.icon className="h-6 w-6 text-sky-500" />
              </div>
              <p className="text-sm font-semibold text-slate-800 tracking-wide uppercase font-body">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
